import { useBlog } from "../context/BlogContext";

export const Subtitle = () => {
    const {settings} = useBlog()
    const [subTitle] = settings?.filter(f => f.id === 'general')?.map(i=>i?.subtitle)
    console.log(subTitle, settings)
    return(
        <h3>{subTitle}</h3>
    )
}